import { AxiosError } from 'axios'

type TreeunfeError = {
  code: string
  message: string
}

export type TreeunfeAxiosError = AxiosError<any, TreeunfeError>

const TIME = 1000

export function errorHandler(error: TreeunfeAxiosError | AxiosError) {
  if (error.response) {
    const { code, message } = error.response.data.data
    console.error(`Ocorreu um erro - code:${code} message: ${message}`)

    if (message) {
      setTimeout(() => {
        console.error(message)
      }, TIME)
    } else {
      console.error(`Ocorreu um erro - code:${code} message: ${message}`)
    }
  } else {
    console.error(error?.message)
    setTimeout(() => {
      console.error(
        `Ocorreu um erro - code:[${error?.status}] message: ${error?.message}`,
      )
    }, TIME)
  }

  throw error
}
